/**
 * Example page using the ComingSoon component.
 * Use this for routes under development, or import ComingSoon directly.
 *
 * Usage in Routing.tsx:
 *   <Route path="/league-management" element={<ComingSoonPage />} />
 *
 * Or use ComingSoon directly with custom props:
 *   <ComingSoon
 *     logoSrc={Images.main_logo}
 *     headline="Your Feature Coming Soon..."
 *     description="This feature is under development and will be available soon.\nStay tuned!"
 *   />
 */
import ComingSoon from '../../components/common/ComingSoon';
import { Images } from '../../utils/imageConstants';

const ComingSoonPage = () => (
  <ComingSoon
    logoSrc={Images.main_logo}
    headline="League Management Feature Coming Soon..."
    description="This feature is under development and will be available soon.
Stay tuned!"
  />
);

export default ComingSoonPage;
